import { IChartInfo } from "../../common/interfaces/chart.interface";
import { IWithdrawalOverview } from "../../common/interfaces/club.interface";
import { get } from "../utilities/http";
import { WITHDRAWAL_CHART, WITHDRAWAL_OVERVIEW } from "../utilities/urls";

export function getWithdrawalOverview(): Promise<IWithdrawalOverview> {
  return get(WITHDRAWAL_OVERVIEW);
}

export function getWithdrawalChartInfo(): Promise<IChartInfo> {
  return get(WITHDRAWAL_CHART);
}
